import { render, staticRenderFns } from "./QuantityFeature.vue?vue&type=template&id=6e1b7f72&scoped=true&"
import script from "./QuantityFeature.vue?vue&type=script&lang=ts&"
export * from "./QuantityFeature.vue?vue&type=script&lang=ts&"
import style0 from "./QuantityFeature.vue?vue&type=style&index=0&id=6e1b7f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1b7f72",
  null
  
)

component.options.__file = "QuantityFeature.vue"
export default component.exports